// Needed because the TranslatePipe is not standalone
import { NgModule } from '@angular/core';
import { TranslatePipe } from '../pipes/translate.pipe';

@NgModule({
  declarations: [TranslatePipe],
  exports: [TranslatePipe],
})
export class TranslateModule {}
